import React, { useEffect, useState } from 'react'
import { backend_api } from '../helper/constant';
import { Link } from 'react-router-dom';

export default function TopFooter() {
    const [risers, setRisers] = useState([])
    const [fallers, setFallers] = useState([])

    useEffect(() => {
        const fetchCoins = async () => {

            try {
                const response = await backend_api.get(`get-coin.php?limit=5&sort_column=change_pct&sort_order=DESC`);
                if (response && response.data) {
                    setRisers(response.data.data.data);
                }

                const response1 = await backend_api.get(`get-coin.php?limit=5&sort_column=change_pct&sort_order=ASC`);
                if (response1 && response1.data) {
                    setFallers(response1.data.data.data);
                }
            } catch (error) {
                console.error('Error fetching coins:', error);
            }
        };

        fetchCoins();
    }, []);

    return (
        <footer class="page-footer">
            <div class="container section">
                <div class="row">
                    <div class="col s12 m12 l6">
                    </div>
                    <div class="col s12 m6 l3">
                        <h5><span>Top Gainers</span></h5>
                        <ul>
                            {risers && risers.map((items, key) => (
                                <li key={key}><a href={`https://markets.blockstar.site/coin/${items.symbol}`}>{items.name}</a><span class="right change change-up">{items.change_pct}%</span></li>
                            ))}
                        </ul>
                        <Link to="/risers" class="right"><i class="material-icons">keyboard_arrow_right</i>View all</Link>
                    </div>
                    <div class="col s12 m6 l3">
                        <h5><span>Top Losers</span></h5>
                        <ul>
                            {fallers && fallers.map((items, key) => (
                                <li key={key}><a href={`https://markets.blockstar.site/coin/${items.symbol}`}>{items.name}</a><span class="right change change-down">{items.change_pct}%</span></li>
                            ))}
                        </ul>
                        <Link to="/fallers" class="right"><i class="material-icons">keyboard_arrow_right</i>View all</Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}
